import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { AwardUnitSelector, Modal } from 'containers/misc'
import { Input } from 'components/fields'
import { Module, ModuleLink } from 'components/misc'
import { modal } from 'redux/modules/app'
import { apiOrganizations } from 'helpers/decorators/api'
import { permissions } from 'helpers/decorators'
import { get } from 'lodash'
import styles from './leader-award-units.styl'
import appConfig from 'config'

@connect(({ form }) => ({
  leaderDetail: form.leaderDetail
}), {
  modal
})
@apiOrganizations({
  myDetail: true
})
@permissions()
export default class LeaderAwardUnit extends PureComponent {
  static propTypes = {
    activeOrganization: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    moveLeader: PropTypes.func.isRequired,
    leaderDetail: PropTypes.object,
    permissions: PropTypes.object
  }

  handleChangeAwardUnit = () => this.props.modal('modal-change-award-unit')

  handleAddMoreAwardUnits = () => this.props.modal('modal-add-more-award-units')

  render () {
    const { leaderDetail, permissions: appPermissions, activeOrganization } = this.props

    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': this.handleChangeAwardUnit,
        'iconAction': null,
        'isActionLoading': false,
        'intlKeyAction': 'button.change',
        'action': 'Change'
      }
    ]

    return (
      <div>
        <Module
          title="Award Unit"
          intlKey="moduleTitle.award_unit"
          buttonDefinition={buttonDefinition}
          primary
        >
          <br />
          <div className="row">
            <div className="col-xs-6">
              <Input
                label="Name"
                name="organization.name"
                intlKey="label.name"
                disabled
              />
            </div>
            <div className="col-xs-6">
              {!appPermissions.isLeader ? <div>
                  <label className={`${styles.label}`}>ID</label>
                  <br />
                  <div className={`${styles.link_container}`}>
                    <ModuleLink
                      to={`${appConfig.publicPath}/award-units/${get(leaderDetail, 'values.organization.id')}/detail`}
                      text={get(leaderDetail, 'values.organization.globalId')}
                    />
                  </div>
                </div>
                :
                <Input
                  label="Region"
                  name="organization.region.name"
                  intlKey="label.region"
                  disabled
                />
              }
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <Input
                label="Type"
                name="organization.organizationType.translationText"
                intlKey="label.type"
                disabled
              />
            </div>
            <div className="col-xs-6">
              <Input
                label="Position in organization"
                name="organizationRole"
                intlKey="label.position_in_organization"
                disabled
              />
            </div>
          </div>
        </Module>
        <Modal id="modal-change-award-unit" customActions fluid>
          <AwardUnitSelector
            modal={this.props.modal}
            moveLeader={this.props.moveLeader}
            activeOrganization={activeOrganization}
          />
        </Modal>
      </div>
    )
  }
}
